import * as api from '../../api/api-area-busqueda-ingreso-recuperos-cuota';
import { 
    OBTENER_LLAVES,
    GET_CONFIG_FORM87,
    GET_FECHAS_IR,
    GET_COMBO_TIPO_FECHA_IR,
    GET_BUSQUEDA_CASOS_IR,
    GET_EXCEL_IR,
    CLEAN_CASOS_IR,
    SET_QUERY_STATE_IR
} from '../types';

export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const configuracionFormAction87 = (query) => ({
    type: GET_CONFIG_FORM87,
    payload: api.getConfiguracionForm87(query)
});
export const obtenerFechas = (query) => ({
    type: GET_FECHAS_IR,
    payload: api.getFechas(query)
});
export const obtenerComboTipoFecha = (query) => ({
    type: GET_COMBO_TIPO_FECHA_IR,
    payload: api.getComboTipoFecha(query)
});
export const obtenerCasos = (query) => ({
    type: GET_BUSQUEDA_CASOS_IR,
    payload: api.getCasos(query)
});
export const obtenerExcel = (query) => ({
    type: GET_EXCEL_IR,
    payload: api.getExcel(query)
});
export const limpiarCasos = () => ({
    type: CLEAN_CASOS_IR,
  
});
export const setQueryState = (data) => ({
    type: SET_QUERY_STATE_IR,
    payload:data
  
});


